module.exports = __webpack_public_path__ + "img/ai_teacher_Michael.c2ab0a35.png";